/**
 * Ryan O'Dowd
 * 2018-04-16
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Badge from '@components/common/Badge';
import Icon from '@react-native-vector-icons/material-design-icons';
import React from 'react';
import {
  TouchableOpacity,
} from 'react-native';
import getStyles from './styles';
import glyphMap from '@react-native-vector-icons/material-design-icons/glyphmaps/MaterialDesignIcons.json';
import hooks from '@hooks';

const HeaderIcon = (props: HeaderIconProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <TouchableOpacity
      style={styles.container}
      onPress={props.onPress}
      disabled={props.hideIcon}
    >
      {props.hideIcon
        ? null
        : (typeof props.icon === 'string'
          ? (
            <Icon
              style={styles.icon}
              name={props.icon as keyof typeof glyphMap}
            />
          )
          : props.icon
        )
      }
      <Badge
        visible={props.hasBadge}
        size={12}
        top={8}
        right={8}
      />
    </TouchableOpacity>
  );
};

class HeaderIconProps {
  icon: (keyof typeof glyphMap) | React.ReactNode;
  onPress: () => void;

  hideIcon?: boolean;
  hasBadge?: boolean;
};

export default HeaderIcon;
